import React from "react";

import { usePartenairesSettings } from "./hooks/usePartenairesSettings";

import PartenairesHeader from "./components/PartenairesHeader";
import PartenairesKpiCards from "./components/PartenairesKpiCards";
import PartenairesFiltersCard from "./components/PartenairesFiltersCard";
import PartenairesTable from "./components/PartenairesTable";
import PartenaireFormDrawer from "./components/PartenaireFormDrawer";
import PartenaireImageUploadModal from "./components/PartenaireImageUploadModal";
import PartenairesPreviewCard from "./components/PartenairesPreviewCard";

export default function SettingsPartenaires() {
  const dashboard = usePartenairesSettings();

  return (
    <div className="space-y-5">
      <PartenairesHeader onCreate={dashboard.openCreateDrawer} />

      <PartenairesKpiCards
        stats={dashboard.stats}
        filteredStats={dashboard.filteredStats}
        loading={dashboard.loading}
      />

      <PartenairesFiltersCard
        filters={dashboard.filters}
        setFilter={dashboard.setFilter}
        resetFilters={dashboard.resetFilters}
        filteredCount={dashboard.filteredPartenaires.length}
        totalCount={dashboard.partenaires.length}
        loading={dashboard.loading}
        onRefresh={dashboard.fetchPartenaires}
      />

      <PartenairesTable
        partenaires={dashboard.filteredPartenaires}
        loading={dashboard.loading}
        deletingId={dashboard.deletingId}
        togglingId={dashboard.togglingId}
        reordering={dashboard.reordering}
        onEdit={dashboard.openEditDrawer}
        onDelete={dashboard.handleDeletePartenaire}
        onToggleActive={dashboard.handleToggleActive}
        onMoveUp={(partenaire) => dashboard.movePartenaire(partenaire.id, "up")}
        onMoveDown={(partenaire) =>
          dashboard.movePartenaire(partenaire.id, "down")
        }
        onUpload={dashboard.openUploadModal}
      />

      <PartenairesPreviewCard partenaires={dashboard.partenaires} />

      <PartenaireFormDrawer
        isOpen={dashboard.formDrawerOpen}
        mode={dashboard.formMode}
        partenaire={dashboard.editablePartenaire}
        nextOrder={dashboard.nextOrder}
        submitting={dashboard.submittingForm}
        onClose={dashboard.closeFormDrawer}
        onSubmit={dashboard.handleSubmitPartenaire}
      />

      <PartenaireImageUploadModal
        isOpen={dashboard.uploadModalOpen}
        partenaire={dashboard.uploadingPartenaire}
        uploadTarget={dashboard.uploadTarget}
        selectedFile={dashboard.selectedFile}
        filePreview={dashboard.filePreview}
        uploading={dashboard.uploading}
        uploadProgress={dashboard.uploadProgress}
        onClose={dashboard.closeUploadModal}
        onTargetChange={dashboard.setUploadTarget}
        onFileChange={dashboard.handleUploadFileChange}
        onSubmit={dashboard.handleUploadSubmit}
      />
    </div>
  );
}